import { Spacing } from '@persona-id/design-tokens';
import { useState } from 'react';
import styled from 'styled-components';

import AsyncImage from 'dashboard/components-lib/AsyncImage';
import { GovernmentIdFile, GovernmentIdPage, PAGE_TO_LABEL } from 'dashboard/models/verification';
import { paragraphMixins } from 'design-system/mixins/text';
import useInterval from 'lib/hooks/useInterval';

const PhotoLabel = styled.p`
  ${paragraphMixins.lgBold};
  margin: ${Spacing[2]} 0;
`;

interface LivePhotoProps {
  files: GovernmentIdFile[];
  page: GovernmentIdPage;
}

const LIVE_PHOTO_SPEED = 500;

const LivePhoto = ({ files, page }: LivePhotoProps) => {
  const [counter, setCounter] = useState(0);
  useInterval({
    callback: async () => {
      setCounter((livePhotoCounter) => livePhotoCounter + 1);
    },
    delay: LIVE_PHOTO_SPEED,
  });

  const label = PAGE_TO_LABEL[page];
  const normalizedFiles = files.filter((file) => file.page === page)[0]['normalized-files'];
  const index = counter % normalizedFiles.length;

  return (
    <div data-test={'verification-detail__government-id-live-photos__' + page}>
      <AsyncImage
        value={[{ url: normalizedFiles[index].url }]}
        width='initial'
        height='250px'
        modalLabel={label}
        allowModalExpand={true}
      />
      <PhotoLabel>{label}</PhotoLabel>
    </div>
  );
};

export default LivePhoto;
